import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'

import { crudActionsMap } from 'utils/helpers'
import AttendanceForm from 'components/organisms/forms/AttendanceForm'



const AttendanceCrudPage = ({report = false}) => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id
  const action = crudActionsMap[params['*']?.split('/')?.[1]]

  const viewOnly = report || action === 'view' || action === 'delete' 

  return (
    <>
      <PageHeading title={`${t('common.attendance')} / ${t('common.' + action)}`} />
      <PageBody>
        <AttendanceForm report={report} action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default AttendanceCrudPage
